import React from 'react'

import { IconTitleDescriptionType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { Carousel } from '@organisms/Carousel'

import { TitleSection } from './IconTitleDescription.styled'
import { IconTitleDescriptionItem } from './IconTitleDescriptionItem/IconTitleDescriptionItem'
import { getGroupedItems } from './utils'

export const IconTitleDescription = (props: IconTitleDescriptionType): JSX.Element => {
    const { title, subtitle, additionalServiceDescription, services, theme } = props

    const serviceItems = getGroupedItems(services)

    return (
        <TitleSection title={title} subtitle={subtitle} description={additionalServiceDescription} mode={theme}>
            <Carousel desktopColumn>
                {serviceItems.map((service, i) => (
                    <Grid container xsSpacingRight={3} key={`icon-title-description-row-${i}`}>
                        {service.map((item, j) => (
                            <Grid
                                item
                                xs={12}
                                md={4}
                                spacingBottom={10}
                                mdUpSpacingBottom={20}
                                mdUpSpacingRight={6}
                                key={`icon-title-description-item-${j}`}
                            >
                                <IconTitleDescriptionItem item={item} mode={theme} />
                            </Grid>
                        ))}
                    </Grid>
                ))}
            </Carousel>
        </TitleSection>
    )
}
